import React from 'react';
import { SummaryItemWithEdit } from '../../../../shared/Summary/SummaryItem/SummaryItemWithEdit';
import { SmallBodyText, TextField } from '../../../../../ui-toolkit';
import { useUpdateOrderFromSummaryItem } from "../hooks/useUpdateOrderFromSummaryItem";

export const RelocationEmployer: React.FC = () => {
  const { order, onPatchOrderInformation } = useUpdateOrderFromSummaryItem();

  return (
    <SummaryItemWithEdit
      label={'Relocation Employer Name'}
      tab={'summary'}
      field={'relocation_employer_name'}
      data-test-id={'relocation-employer-name'}
      onUpdate={(_, value) => onPatchOrderInformation({ relocationEmployerName: value })}
      order={order}
      editControl={TextField}
      editProps={{ placeholder: 'John Smith' }}
    >
      {order.transaction.relocation_employer_name ?? <SmallBodyText intent={'faded'}>-</SmallBodyText>}
    </SummaryItemWithEdit>
  );
};
